import { render, staticRenderFns } from "./Decks.vue?vue&type=template&id=65baf644&scoped=true&"
import script from "./Decks.vue?vue&type=script&lang=js&"
export * from "./Decks.vue?vue&type=script&lang=js&"
import style0 from "./Decks.vue?vue&type=style&index=0&id=65baf644&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65baf644",
  null
  
)

export default component.exports